import React from 'react';

import styled from 'styled-components';
import LocalStorageHelper from '../../../Utilities/Helpers/LocalStorageHelper';
import { Card, Paper } from '@mui/material';
import { CustomDetailsCardInterface } from '../../../Models/Common/CustomViewsInterfaces';

import CustomDetailsHeader from '../CustomDetailsHeader/CustomDetailsHeader';

const DetailCardContainer = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none;
    border-radius: 0px !important;
    box-shadow: none !important;

    .companyModulesTable {
        thead {
            tr {
                th {
                    &:last-of-type {
                        display: flex;
                        justify-content: unset;
                    }
                }
            }
        }

        tbody {
            tr {
                td {
                    &:last-of-type {
                        display: flex;
                        justify-content: unset;
                    }
                }
            }
        }
    }
`;

const StyledPaper = styled(Paper) <{ $darkMode?: boolean; }>`
    box-shadow: none !important;
    border: 1px solid;
    border-top: none;
    border-radius: 0px 0px 5px 5px !important;
    padding: 15px;
    text-align: left;
    // background: #f9fbfc !important;
`;

const CustomDetailsCard = (props: CustomDetailsCardInterface) => {
    return <DetailCardContainer className="customDetailsCard">
        <CustomDetailsHeader
        title={props?.title ?? null}
        actionButtons={props?.actionButtons ?? null}
        isNoPadding={props?.isNoPadding ?? false}
        isTitleNotText={props?.isTitleNotText ?? false} />
        <StyledPaper className="customStyledPaper" sx={{borderColor: 'customBorder.main', backgroundColor: (props?.isInvoiceDetails ? 'customBackground.invoice' : 'customBackground.main')}}>
            {props?.children ?? ""}
        </StyledPaper>
        </DetailCardContainer>
}

export default CustomDetailsCard;